import { useAuth } from "@/contexts/AuthContext";

export default function Profile() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div>
      <div className="overline mb-4">Profile</div>
      <div className="border border-black/10 p-6">
        <dl>
          <div className="data-row"><dt>Name</dt><dd>{user.name}</dd></div>
          <div className="data-row"><dt>Email</dt><dd>{user.email}</dd></div>
          <div className="data-row"><dt>Role</dt><dd>{user.role}</dd></div>
          <div className="data-row"><dt>Joined</dt><dd>{new Date(user.created_at).toLocaleDateString()}</dd></div>
        </dl>
      </div>
    </div>
  );
}
